/**
 * Beta gate per la route "Arricchimento Lead" (/settings/enrichment).
 *
 * Se l'org corrente non e` in LEAD_ENRICHMENT_ORG_IDS, redirect a / (home).
 * Non sostituisce ProtectedRoute: si usano insieme.
 *   <EnrichmentRoute>
 *     <ProtectedRoute resource="lead_enrichment" action="view">
 *       <EnrichmentSettingsPage />
 *     </ProtectedRoute>
 *   </EnrichmentRoute>
 *
 * Quando si apre la feature a tutti: rimuovere wrapper dalla route in App.tsx +
 * rimuovere _betaOrgIds dal menu + svuotare LEAD_ENRICHMENT_ORG_IDS (vedi config/betaOrgs.ts).
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserData } from '../lib/auth';
import { LEAD_ENRICHMENT_ORG_IDS, canAccessBetaFeature } from '../lib/config/betaOrgs';

interface Props {
  children: React.ReactNode;
}

export function EnrichmentRoute({ children }: Props) {
  const { organizationId, loading } = useUserData();

  // Aspetta il caricamento dei dati org prima di decidere (evita redirect spurio
  // durante il primo render della SPA).
  if (loading) return null;

  if (!canAccessBetaFeature(LEAD_ENRICHMENT_ORG_IDS, organizationId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
